import React from 'react';
import BackButton from './BackButton';
import './LoginPrompt.css';

const LoginPrompt = ({ icon, title, message, onLoginClick, onBackClick }) => (
  <div className="login-prompt-page">
    {onBackClick && <BackButton onClick={onBackClick} />}
    <div className="login-prompt-center">
      {icon && <div className="login-prompt-icon">{icon}</div>}
      {title && <h1>{title}</h1>}
      <p>{message}</p>
      <button type="button" className="login-prompt-btn" onClick={onLoginClick}>
        Login &amp; Register
      </button>
    </div>
  </div>
);

export default LoginPrompt;
